import { addSpaceIfNeeded } from "../addSpaceIfNeeded";

export const addAOCreatorsToLayout = (
  newLayout,
  format,
  campaignId,
  provider,
  overlapData,
) => {
  const creators = overlapData?.audienceOverlap?.data || [];

  creators.map((creator) => {
    const lastEl = addSpaceIfNeeded("overlap-creator", newLayout, format);

    const x = 0;
    const y = lastEl.y + lastEl.h;
    const w = 12;
    const h = 2;

    const i = `overlap-creator-${provider}-${creator.userId}-${campaignId}`;
    newLayout.push({ i, x, y, w, h });
  });
};
